import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Body1, colors, H3, spacing, link } from 'ui/theme';

export const GeneralErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${colors.backgroundSecondary};
  height: ${spacing.x32};
`;

export const MainText = styled(H3)`
  margin: 0 0 ${spacing.half} 0;
`;

export const CaptionText = styled(Body1)`
  color: ${colors.textSecondary};
`;

export const GoalsLink = styled(Link)`
  ${link};
`;
